import { Paper } from '@mui/material';
import React from 'react';
import Components from './ComponentsList';

const LeftBar: React.FC<{}> = () => (
	<Paper
		sx={{
			height: '100%',
			minWidth: 180,
			overflow: 'hidden',
			display: 'flex',
			flexDirection: 'column'
		}}
		data-testid="page-editor-left-bar"
	>
		<Components />
	</Paper>
);

export default LeftBar;
